

export class ToolTipHeaderUpdateInput implements IToolTipHeaderUpdateInput {
    /** The auto-generated id of the tool tip header master */
    tooltipHeaderId!: number;
    /** The header name with 255 character limit */
    tooltipHeaderName!: string;

    constructor(data?: IToolTipHeaderUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltipHeaderId = _data["tooltipHeaderId"];
            this.tooltipHeaderName = _data["tooltipHeaderName"];
        }
    }

    static fromJS(data: any): ToolTipHeaderUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipHeaderUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipHeaderId"] = this.tooltipHeaderId;
        data["tooltipHeaderName"] = this.tooltipHeaderName;
        return data; 
    }
}

export interface IToolTipHeaderUpdateInput {
    /** The auto-generated id of the tool tip header master */
    tooltipHeaderId: number;
    /** The header name with 255 character limit */
    tooltipHeaderName: string;
}

